// extracted by mini-css-extract-plugin
export default {"title":"FaqCategory_title__6rubp","questionsCategory":"FaqCategory_questionsCategory__6lVh-","showMore":"FaqCategory_showMore__L3tfL"};